module.exports = __webpack_public_path__ + "img/shop.f3a2618f.svg";